import logo from './logo.svg';
import './App.css';
import Navbar from './components/navbar';
import Homepage from './components/HomePage';
import Footer from './components/footer';
import About from './components/about';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Academics from './components/academics';
import Admissions from './components/admissions';
import Events from './components/events';
import Primary from './components/primarylevel';
import StudentLife from './components/studentlife';
import Form from './components/form';
import AdmissionForm from './components/Admisssionsform';
import AcademicPrograms from './components/rankridgegrades';
import PhoneOtpPopup from './components/phoneOtpPopup';
import WhatsApp from './components/WhatsApp';
import CallButton from './components/callbuttons';
import Blogs from "./components/Blogs"
import Contact from './components/contact';
import MpcWithIIT from './components/mpcWithIIT-JEE';
import LongtermWithIITJee from './components/LongtermWithIIT-Jee';
import Eapcet from './components/Eapcet';
import Intermediate from './components/Intermediate';
import BipcWithNeet from './components/BipcWithNeet';
import Shortterm from './components/shortterm';
import TrackReacords, { TrackRecords } from './components/TrackRecords';
import Gallery from './components/gallery';
import NeetLongTerm from './components/neet';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import TermsAndConditions from './components/termsandconsitions';
import PrivacyPolicy from './components/privacypolocy';
import RankridgeLanding from './components/Home';
import { CTASection } from './components/courses/commoncomponents';
import ContactPage from './components/contactus';
import ScrollToTop from './components/subcomponents/ScrollToTop';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Navbar/>
      <WhatsApp />
          <CallButton />
                <ScrollToTop />

      <Routes>
    <Route path='/' element={ <RankridgeLanding/>}/>
       <Route path='/terms-and-conditions/' element={ <TermsAndConditions/>}/>


       <Route path='/privacy-policy/' element={ <PrivacyPolicy/>}/>

    <Route path='/about-us/' element={ <About/>}/>
    <Route path='/contact-us/' element={<ContactPage />}/>
    <Route path='/mpc-with-iit-jee/' element={<MpcWithIIT />}/>
    <Route path='/engineering-medical-entrance-coaching-in-hyderabad/' element={ <LongtermWithIITJee />}/>
     <Route path='/eamcet-coaching-in-hyderabad/' element={<Eapcet/>}/>
      <Route path='/best-junior-college-in-hyderabad/' element={ <Intermediate/>}/>
      <Route path='/best-neet-coaching-center-in-hyderbad/' element={ <BipcWithNeet/>}/>
      <Route path='/iit-jee-neet-eamcet-bitsat-short-term-coaching-hyderabad/' element={ <Shortterm/>}/>
       <Route path='/track-records' element={ <TrackRecords/>}/>
       <Route path='/gellary' element={ <Gallery/>}/>
          <Route path='/neet-coaching-in-hyderabad/' element={ <NeetLongTerm/>}/>

          <Route path='/signup/' element={ <ContactPage />}/>

          <Route path='/blog' element={<BlogList />}/>
        <Route path='/blog/:slug' element={<BlogPost />}/>

        <Route path='*' element={<Homepage />}/>
    </Routes>
     
    <Footer />
  
    </BrowserRouter>

    </div>
  );
}

export default App;
